import { isUrl } from '@/common/reg'

export default {
  // RULE: 品牌名称
  brandName: () => [
    { required: true, message: '请填写品牌名称', trigger: 'blur' },
    { min: 2, max: 20, message: '限制输入2-20个字', trigger: 'blur' }
  ],

  // RULE: 品牌英文名称
  brandEnglishName: () => [
    { required: false, message: '', trigger: 'blur' },
    { max: 20, message: '限制输入 20 个字', trigger: 'blur' },
    {
      trigger: 'blur',
      validator: (rule, value, callback) => {
        callback(value && !/[A-Za-z\s]+/.test(value) ? new Error('请正确输入英文名称') : undefined)
      }
    }
  ],

  // RULE: 品牌Logo
  brandLogo: () => [
    {
      required: true,
      trigger: 'change',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('请上传品牌logo'))
        else callback()
      }
    }
  ],

  // RULE: 品牌标语
  brandSlogan: () => [
    { required: true, message: '请填写品牌slogan', trigger: 'blur' },
    { min: 0, max: 20, message: '限制输入20个字', trigger: 'blur' }
  ],

  // RULE: 品牌介绍
  brandIntroduction: () => [
    { required: true, message: '请填写品牌介绍', trigger: 'blur' },
    { min: 2, max: 300, message: '限制输入2-300个字', trigger: 'blur' }
  ],

  // RULE: 品牌类型
  brandType: () => [
    { required: true, message: '请选择品牌类型', trigger: 'change' }
  ],

  // RULE: 经营类型
  managementType: () => [
    { required: true, message: '请选择经营类型', trigger: 'change' }
  ],

  // RULE: 代理授权书
  proxyInfosObjectId: () => [
    { required: true, message: '请上传代理授权书', trigger: 'blur' }
  ],

  // RULE: 代理授权书 - 开始日期
  proxyInfosStartDate: () => [
    { required: true, message: '请选择授权书有效开始日期', trigger: 'change' }
  ],

  // RULE: 代理授权书 - 结束日期
  proxyInfosEndDate: (getStartDate, index) => [
    {
      required: true,
      trigger: 'change',
      validator: (rule, value, callback) => {
        const dateToDateTime = (strtime) => {
          if (strtime.indexOf('T') !== -1 || strtime.indexOf('Z') !== -1) return new Date(strtime).getTime()
          else return new Date(strtime.replace(/-/g, '/')).getTime()
        }
        if (!value) callback(new Error('请选择授权书有效结束日期'))
        const startTime = dateToDateTime(getStartDate(index))
        const endTime = dateToDateTime(value)
        if (value && endTime < startTime) callback(new Error('有效结束日期不能小于有效开始日期'))
        else callback()
      }
    }
  ],

  // RULE: 商标资质类型
  trademarkQualificationType: () => [
    { required: true, message: '请选择商标资质类型', trigger: 'change' }
  ],

  // RULE: 商标证 / 商标受理通知书
  trademarkQualificationObjectId: (getType) => [
    {
      required: true,
      trigger: 'change',
      validator: (rule, value, callback) => {
        const type = getType()
        if (!value) callback(new Error(`请上传${type === 1 ? '商标证' : '商标受理通知书'}`))
        else callback()
      }
    }
  ],

  // RULE: 商标注册人 / 商标申请人
  trademarkQualificationRegistrant: (getType) => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        const type = getType()
        if (!value) callback(new Error(`请填写${type === 1 ? '商标注册人' : '商标申请人'}`))
        else if (type === 1 && value.length > 20) callback(new Error('限制输入20个字'))
        else if (type === 2 && value.length > 30) callback(new Error('限制输入30个字'))
        else callback()
      }
    }
  ],

  // RULE: 商标类别
  trademarkQualificationCategory: () => [
    { required: true, message: '请填写商标类别', trigger: 'blur' },
    { min: 0, max: 20, message: '限制输入20个字', trigger: 'blur' }
  ],

  // RULE: 商标号 / 申请号
  trademarkQualificationNumber: (getType) => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        const type = getType()
        if (!value) callback(new Error(`请填写${type === 1 ? '商标号' : '申请号'}`))
        else callback()
      }
    },
    { min: 0, max: 20, message: '限制输入20个字', trigger: 'blur' }
  ],

  // RULE: 目标到期日 - 起始日期
  trademarkQualificationStartDate: (isLongTime, getType) => [
    {
      trigger: 'change',
      validator: (rule, value, callback) => {
        const longTime = isLongTime()
        if (!longTime && !value && getType() === 1) callback(new Error('请选择开始日期'))
        else callback()
      }
    }
  ],

  // RULE: 目标到期日 - 结束日期
  trademarkQualificationEndDate: (isLongTime, getType) => [
    {
      trigger: 'change',
      validator: (rule, value, callback) => {
        const longTime = isLongTime()
        if (!longTime && !value && getType() === 1) callback(new Error('请选择结束日期'))
        else callback()
      }
    }
  ],

  proofName: () => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('输入店铺名称'))
        else callback()
      }
    }
  ],

  thirdPartyUrl: () => [
    {
      required: true,
      trigger: 'blur',
      validator: (rule, value, callback) => {
        if (!value) callback(new Error('输入店铺链接'))
        if (value && !isUrl.test(value)) callback(new Error('请正确输入链接'))
        else callback()
      }
    }
  ]
}
